<div [class]="'dashboard-container' + ' dashboard-id-' + dashboardId">
  <div *ngIf="dashboardStructure === undefined">
    <nz-spin></nz-spin>
  </div>
  <div *ngIf="dashboardStructure !== undefined">
    <h2 style="padding-left: 15px;">
      {{dashboardStructure.Title | locale}}
    </h2>
    <div nz-row *ngFor="let container of dashboardStructure.Containers">
      <div nz-col [nzXl]="getColumnWidth(column)" [nzLg]="getColumnWidth(column)" [nzMd]="getColumnWidth(column)"
        [nzSm]="24" [nzXs]="24" *ngFor="let column of container.Columns">
        <app-params-base style="display: block;float: right;width: 400px;" *ngIf="column.ColumnType === 'Parameters'"
          [parameters]="column.Parameters" [dashboardParams]="dashboardParams" [dashboardId]="dashboardId"
          [dashboardParamNames]="dashboardParamNames">
        </app-params-base>
      </div>
      <div nz-col [nzXl]="getColumnWidth(column)" [nzLg]="getColumnWidth(column)" [class]="column.CssClass" [nzMd]="getColumnWidth(column)"
        [nzSm]="24" [nzXs]="24" *ngFor="let column of container.Columns">
        <app-widget *ngIf="column.ColumnType === 'Widget'" [width]="getColumnWidth(column)" [widgetId]="column.WidgetId" [dashboardId]="dashboardId" [withBorders]="column.WithBorders"
          [dashboardParamNames]="dashboardParamNames">
        </app-widget>
      </div>
    </div>
  </div>
</div>